import api from './authService';

export const banksAPI = {
  getAll: (params) => api.get('/banks', { params }),
  getById: (id) => api.get(`/banks/${id}`),
  create: (data) => api.post('/banks', data),
  update: (id, data) => api.put(`/banks/${id}`, data),
  delete: (id) => api.delete(`/banks/${id}`),
};

export const bankLimitsAPI = {
  getAll: (params) => api.get('/bank-limits', { params }),
  getById: (id) => api.get(`/bank-limits/${id}`),
  create: (data) => api.post('/bank-limits', data),
  update: (id, data) => api.put(`/bank-limits/${id}`, data),
  delete: (id) => api.delete(`/bank-limits/${id}`),
  getUtilization: (id) => api.get(`/bank-limits/${id}/utilization`),
  getFullCashPolicy: (id) => api.get(`/bank-limits/${id}/full-cash-policy`),
};

export const cashMarginAPI = {
  getAll: (params) => api.get('/cash-margin-deposits', { params }),
  getById: (id) => api.get(`/cash-margin-deposits/${id}`),
  create: (data) => api.post('/cash-margin-deposits', data),
  update: (id, data) => api.put(`/cash-margin-deposits/${id}`, data),
  release: (id, data) => api.post(`/cash-margin-deposits/${id}/release`, data),
  delete: (id) => api.delete(`/cash-margin-deposits/${id}`),
};

export const bgReportsAPI = {
  getBankWiseEligibility: (params) => api.get('/bg-reports/bank-wise-eligibility', { params }),
  getBankWiseUtilization: (params) => api.get('/bg-reports/bank-wise-utilization', { params }),
  getBankWiseExposure: (params) => api.get('/bg-reports/bank-wise-exposure', { params }),
  getAmountVsBank: (params) => api.get('/bg-reports/amount-vs-bank', { params }),
  getCashMarginRegister: (params) => api.get('/bg-reports/cash-margin-register', { params }),
  getFullCashBacked: (params) => api.get('/bg-reports/full-cash-backed', { params }),
  getProjectWiseExposure: (params) => api.get('/bg-reports/project-wise-bg-exposure', { params }),
  getExpiryRenewal: (params) => api.get('/bg-reports/expiry-renewal', { params }),
  getTypeWiseSummary: (params) => api.get('/bg-reports/type-wise-summary', { params }),
  getRenewalHistory: (params) => api.get('/bg-reports/renewal-history', { params }),
};

export const bankGuaranteesEnhancedAPI = {
  getRenewals: (id) => api.get(`/bank-guarantees/${id}/renewals`),
  renew: (id, data) => api.post(`/bank-guarantees/${id}/renew`, data),
  release: (id, data) => api.post(`/bank-guarantees/${id}/release`, data),
  close: (id, data) => api.post(`/bank-guarantees/${id}/close`, data),
  changeLimitConsumption: (id, data) => api.post(`/bank-guarantees/${id}/change-limit-consumption`, data),
  generateRenewalReminders: () => api.post('/bg-renewal-reminders/generate'),
};
